
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.7305 17.8417L13.4459 18.984C12.5921 19.3149 11.9101 19.5668 11.4022 19.7399C10.8937 19.9136 10.303 20 9.62989 20C8.59624 20 7.79225 19.7514 7.21883 19.2576C6.64541 18.7618 6.35861 18.1335 6.35861 17.3713C6.35861 17.0763 6.37942 16.7728 6.42269 16.4636C6.46632 16.154 6.53569 15.8054 6.63062 15.4157L7.69768 11.7074C7.79261 11.3523 7.8733 11.0159 7.93793 10.6977C8.00347 10.3815 8.03505 10.0906 8.03505 9.82873C8.03505 9.35515 7.93519 9.0239 7.73638 8.83766C7.53758 8.65196 7.15822 8.55768 6.59502 8.55768C6.31917 8.55768 6.03566 8.60106 5.74667 8.68494C5.4564 8.76919 5.2083 8.85057 5 8.92621L5.28534 7.78297C5.98436 7.50352 6.65253 7.26422 7.29167 7.06561C7.93081 6.86647 8.53472 6.76681 9.10595 6.76681C10.1325 6.76681 10.9246 7.01041 11.4809 7.4976C12.0371 7.98516 12.3152 8.61719 12.3152 9.39602C12.3152 9.55717 12.2969 9.8411 12.2577 10.2469C12.2193 10.6536 12.1479 11.0263 12.0439 11.3652L10.9814 15.0587C10.8943 15.3553 10.816 15.6945 10.7479 16.0761C10.6776 16.4552 10.644 16.7448 10.644 16.9392C10.644 17.4296 10.7554 17.7644 10.9786 17.9424C11.2036 18.1204 11.5909 18.2089 12.1412 18.2089C12.3995 18.2089 12.6934 18.164 13.02 18.0756C13.3457 17.9872 13.5832 17.9096 13.7305 17.8417ZM14 2.33561C14 2.97911 13.753 3.52868 13.2566 3.98057C12.7615 4.43407 12.1649 4.661 11.467 4.661C10.7669 4.661 10.1688 4.43407 9.66805 3.98057C9.1682 3.52851 8.91773 2.97911 8.91773 2.33561C8.91773 1.69336 9.1682 1.14289 9.66805 0.685267C10.1679 0.228362 10.7671 0 11.467 0C12.1647 0 12.7615 0.2289 13.2566 0.685267C13.7534 1.14289 14 1.69354 14 2.33561Z"}})])
          )
        }
      }
    